import React, { FunctionComponent } from 'react';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { IntlProvider } from 'react-intl';

import { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';

import MediaQueryProvider from './providers/MediaQueryProvider';
import ScrollContainerProvider from './providers/ScrollContainerProvider';

import Home from './pages/Home';
import Story from './pages/Story';
import { Imprint, DataProtection } from './pages/Imprint';

import { theme } from './theme';
import translations from './translations';

const App: FunctionComponent = () => {
  const { locale, messages } = translations;

  return (
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <MediaQueryProvider>
        <MuiThemeProvider theme={theme}>
          <ThemeProvider theme={theme}>
            <Router>
              <ScrollContainerProvider>
                <Switch>
                  <Route path="/imprint">
                    <Imprint />
                  </Route>
                  <Route path="/data">
                    <DataProtection />
                  </Route>
                  <Route path="/story">
                    <Story />
                  </Route>
                  <Route path="/">
                    <Home />
                  </Route>
                </Switch>
              </ScrollContainerProvider>
            </Router>
          </ThemeProvider>
        </MuiThemeProvider>
      </MediaQueryProvider>
    </IntlProvider>
  );
};

export default App;
